import React from 'react';
import { CloseIcon } from '../../icons/close-icon';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
import { UserIcon } from '../../icons/user-icon';
import { UserGroupIcon } from '../../icons/user-group-icon';
import { useConfiguration } from '../../../context/configuration-context/use-configuration';
import { ANONYMOUS_PUBLISH_SHEET, CANCEL_BTN, PUBLISH_AS_GUEST_BTN, PUBLISH_AS_MEMBER_BTN, } from '../../../../common/constants/data-hooks';
import { ActionSheetModalMobileBase } from '../base/action-sheet-modal-mobile-base/action-sheet-modal-mobile-base';
import { ActionSheetItem } from '../base/action-sheet-modal-mobile-base/action-sheet-item';
const AnonymousPublishSheetModal = ({ toggle, onPublish }) => {
    const t = useTranslate();
    const { blackAndWhiteModals, hideActionMenusIcons } = useConfiguration();
    return (React.createElement(ActionSheetModalMobileBase, { toggle: toggle, dataHook: ANONYMOUS_PUBLISH_SHEET, isBlackAndWhite: blackAndWhiteModals },
        React.createElement(ActionSheetItem, { isBlackAndWhite: blackAndWhiteModals, dataHook: PUBLISH_AS_MEMBER_BTN, label: t('anonymous-publish-sheet-modal.publish-as-member'), onClick: () => {
                onPublish({ asGuest: false });
                toggle();
            }, icon: UserGroupIcon }),
        React.createElement(ActionSheetItem, { isBlackAndWhite: blackAndWhiteModals, dataHook: PUBLISH_AS_GUEST_BTN, label: t('anonymous-publish-sheet-modal.publish-as-guest'), onClick: () => {
                onPublish({ asGuest: true });
                toggle();
            }, icon: UserIcon }),
        React.createElement(ActionSheetItem, { isBlackAndWhite: blackAndWhiteModals, dataHook: CANCEL_BTN, icon: !hideActionMenusIcons && CloseIcon, label: t('anonymous-publish-sheet-modal.publish-cancel'), onClick: toggle })));
};
export default AnonymousPublishSheetModal;
//# sourceMappingURL=anonymous-publish-sheet-modal.js.map